import styled from 'styled-components'

import Input from '@material-ui/core/Input'

const FileUpload = styled(Input)`
  margin: 15px 0 30px;
`

export default FileUpload
